import { createCachedSelector } from 're-reselect';

import getBuildCountsTotal from '@/state/selectors/saved-builds/get-build-counts-total';
import getBuildDataTotal from '@/state/selectors/saved-builds/get-build-data-total';
import { IStore } from '@/state/slices/typings';

const getNormalisedTotal = createCachedSelector(
	[
		getBuildCountsTotal,
		getBuildDataTotal,
		(
			_: IStore,
			activeBrand: 'range-rover' | 'defender' | 'discovery' | undefined,
		) => activeBrand,
	],
	(buildCountsTotal, buildDataTotal) => buildDataTotal ?? buildCountsTotal,
)((_: IStore, activeBrand) => activeBrand || '');

export default getNormalisedTotal;
